import {
  Grid,
  List,
  ListItemText,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { GlobalBox } from "components/Box/GlobalBox";
import React from "react";
import { useSelector } from "react-redux";
import { reasonNotesOptions } from "./config";
import { cleanNumber } from "helpers/cleanNumbers";
import { formatNumber } from "helpers/getNumberFormats";
import { decimalsOptions } from "helpers/dictionary";

export const ResumeInvoice = () => {
  const { breakpoints } = useTheme()
  const md = useMediaQuery(breakpoints.down("md"))
  const { resume: {
    subTotal, iva, total
  }, reasonSelect } = useSelector(({cashInvoices}) => cashInvoices)

  const isFivePerThousand = reasonSelect === reasonNotesOptions.fivePerThousand;
  const retentionValue = isFivePerThousand ? cleanNumber(subTotal) * 0.005 : 0;
  const retention = isFivePerThousand
    ? formatNumber({ input: retentionValue, decimals: decimalsOptions[2]?.value })
    : 0;
  const totalWithRetention = isFivePerThousand
    ? formatNumber({ input: cleanNumber(total) - retentionValue, decimals: decimalsOptions[2]?.value })
    : total;

  return (
    <Grid item xs={12} >
      <GlobalBox title="Resumen" head  style={{ boxShadow: "none", margin: 0 }}>
        <List
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            flexDirection: md ? "column" : "row",
            gap: 8,
          }}
        >
          <ListItemText
            primary={<Typography variant="h5">Subtotal</Typography>}
            secondary={<Typography variant="h5">$ {subTotal}</Typography>}
            style={{
              textAlign: "center",
            }}
          />
          <ListItemText
            primary={<Typography variant="h5">IVA</Typography>}
            secondary={<Typography variant="h5">$ {iva}</Typography>}
            style={{
              textAlign: "center",
            }}
          />
          {isFivePerThousand && (
            <ListItemText
              primary={<Typography variant="h5">Retención 5 al millar</Typography>}
              secondary={<Typography variant="h5">$ {retention}</Typography>}
              style={{
                textAlign: "center",
              }}
            />
          )}
          <ListItemText
            primary={<Typography variant="h5">Total</Typography>}
            secondary={<Typography variant="h5">$ {totalWithRetention}</Typography>}
            style={{
              textAlign: "center",
            }}
          />
        </List>
      </GlobalBox>
    </Grid>
  );
};
